<ng-container *ngIf="!handsetService.isMobile; else mobileTemplate">
  <div fxLayout="column">
    <header *ngIf="title">
      {{ title }}
    </header>
    <ul [fxLayout]="horizontal? 'row' : 'column'">
      <li *ngFor="let button of buttons; let i = index" [fxFlexOffset]="i === 0 ? '0px' : customOffset">
        <app-tile-button
          [url]="button.url"
          [title]="button.title"
          [subtitle]="button.subtitle"
          [icon]="button.icon"
          [disabled]="button.disabled"
          [loading]="button.loading"
          [iconSize]="button.iconSize"
          [onClickFn]="button.onClickFn"
          [titleStyle]="button.titleStyle"
          [customWidth]="button.customWidth"
          [customHeight]="button.customHeight"
          [customPadding]="button.customPadding">
        </app-tile-button>
      </li>
    </ul>
  </div>
</ng-container>


<ng-template #mobileTemplate>
  <div fxLayout="column">
    <header *ngIf="title">
      {{ title }}
    </header>
    <ul [fxLayout]="'column'">
      <li *ngFor="let button of buttons; let i = index">
        <button fxFlex
                fxLayout="row"
                aria-label="{{button.title}}"
                class="li-button"
                [disabled]="button.disabled"
                (click)="onClick(button)">
          <app-icon [name]="button.icon"
                    [width]="button.iconSize"
                    [height]="button.iconSize"
                    style="margin-right: 10px"></app-icon>
          <a *ngIf="button.url; else buttonLabel"
             href="{{button.url}}"
             target="_blank"
             style="flex: 1;align-content: center;">
            {{ button.title }}
          </a>
          <ng-template #buttonLabel>
         <span style="height: 100%">
          {{ button.title }}
        </span>
          </ng-template>
          <app-icon *ngIf="button.url; else rightArrow" [name]="'open_in_new'" [width]="24" [height]="24"></app-icon>
          <ng-template #rightArrow>
            <app-icon [name]="'keyboard_arrow_right'">
            </app-icon>
          </ng-template>
        </button>
      </li>
    </ul>
  </div>
</ng-template>
